import { render } from "./Main.vue?vue&type=template&id=147267e8&ts=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=147267e8&lang=css"

import exportComponent from "/home/runner/work/miki-ihara-law-and-patent-office/miki-ihara-law-and-patent-office/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__